import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Typography, Adaptive } from 'fronton-react';
import { ParametersEnum } from '../../types';
import { AdaptiveSelectionGroup } from './components/adaptive-selection-group';
import { HeaderContainer } from './styles';

export const ColourParams = () => {
  const { control } = useFormContext();

  return (
    <div>
      <HeaderContainer>
        <Adaptive to="tablet">
          <Typography variant="m" color="text-primary" size="subtitle">
            Цвет
          </Typography>
        </Adaptive>
        <Adaptive from="tablet">
          <Typography variant="l" color="text-primary" size="body_accent">
            Цвет
          </Typography>
        </Adaptive>
      </HeaderContainer>
      <Controller
        name={ParametersEnum.colour}
        control={control}
        render={({ field: { onChange, value } }) => (
          <>
            <Adaptive to="tablet">
              <AdaptiveSelectionGroup onChange={onChange} value={value} mobile />
            </Adaptive>
            <Adaptive from="tablet">
              <AdaptiveSelectionGroup onChange={onChange} value={value} mobile={false} />
            </Adaptive>
          </>
        )}
      />
    </div>
  );
};
